"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var cov_95t4sk8rx = function () {
  var path = "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/helpers.js";
  var hash = "12ea8dd0eccecd719c74e7e142a8f3d1ab2ab128";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/GithubWorkspace/gitea-react-toolkit/src/components/authentication/helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 28
        },
        end: {
          line: 6,
          column: 2
        }
      },
      "1": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 8,
          column: 88
        }
      },
      "2": {
        start: {
          line: 8,
          column: 42
        },
        end: {
          line: 8,
          column: 87
        }
      },
      "3": {
        start: {
          line: 10,
          column: 23
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "4": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 69
        }
      },
      "6": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 39
        }
      },
      "7": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 26
        }
      },
      "8": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 24
        }
      },
      "9": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "10": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "11": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 48
        }
      },
      "12": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 74
        }
      },
      "13": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 70
        }
      },
      "14": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 29,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 8,
            column: 32
          }
        },
        loc: {
          start: {
            line: 8,
            column: 42
          },
          end: {
            line: 8,
            column: 87
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 23
          },
          end: {
            line: 10,
            column: 24
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 24
          },
          end: {
            line: 21,
            column: 25
          }
        },
        loc: {
          start: {
            line: 21,
            column: 50
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 21
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 42
          },
          end: {
            line: 8,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 42
          },
          end: {
            line: 8,
            column: 46
          }
        }, {
          start: {
            line: 8,
            column: 50
          },
          end: {
            line: 8,
            column: 60
          }
        }, {
          start: {
            line: 8,
            column: 64
          },
          end: {
            line: 8,
            column: 74
          }
        }, {
          start: {
            line: 8,
            column: 78
          },
          end: {
            line: 8,
            column: 87
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "12ea8dd0eccecd719c74e7e142a8f3d1ab2ab128"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveAuth = exports.getAuth = exports.isAuthenticated = void 0;

var _localforage = _interopRequireDefault(require("localforage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var authenticationStore = (cov_95t4sk8rx.s[0]++, _localforage.default.createInstance({
  driver: [_localforage.default.INDEXEDDB],
  name: 'git-authentication-store'
}));
cov_95t4sk8rx.s[1]++;

var isAuthenticated = function isAuthenticated(auth) {
  cov_95t4sk8rx.f[0]++;
  cov_95t4sk8rx.s[2]++;
  return (cov_95t4sk8rx.b[0][0]++, auth) && (cov_95t4sk8rx.b[0][1]++, auth.token) && (cov_95t4sk8rx.b[0][2]++, auth.token) && (cov_95t4sk8rx.b[0][3]++, auth.user);
};

exports.isAuthenticated = isAuthenticated;
cov_95t4sk8rx.s[3]++;

var getAuth = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var authentication, value;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_95t4sk8rx.f[1]++;
            cov_95t4sk8rx.s[4]++;
            _context.prev = 2;
            cov_95t4sk8rx.s[5]++;
            _context.next = 6;
            return authenticationStore.getItem('authentication');

          case 6:
            value = _context.sent;
            cov_95t4sk8rx.s[6]++;
            authentication = JSON.parse(value);
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            cov_95t4sk8rx.s[7]++;
            authentication = null;

          case 15:
            cov_95t4sk8rx.s[8]++;
            return _context.abrupt("return", authentication);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function getAuth() {
    return _ref.apply(this, arguments);
  };
}();

exports.getAuth = getAuth;
cov_95t4sk8rx.s[9]++;

var saveAuth = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authentication) {
    var response, value;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cov_95t4sk8rx.f[2]++;
            cov_95t4sk8rx.s[10]++;

            if (!authentication) {
              _context2.next = 11;
              break;
            }

            cov_95t4sk8rx.b[1][0]++;
            value = (cov_95t4sk8rx.s[11]++, JSON.stringify(authentication));
            cov_95t4sk8rx.s[12]++;
            _context2.next = 8;
            return authenticationStore.setItem('authentication', value);

          case 8:
            response = _context2.sent;
            _context2.next = 16;
            break;

          case 11:
            cov_95t4sk8rx.b[1][1]++;
            cov_95t4sk8rx.s[13]++;
            _context2.next = 15;
            return authenticationStore.removeItem('authentication');

          case 15:
            response = _context2.sent;

          case 16:
            cov_95t4sk8rx.s[14]++;
            return _context2.abrupt("return", response);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function saveAuth(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.saveAuth = saveAuth;